function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a1",
  x1: "100%",
  y1: "125.759%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#181A2F",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F90",
  stopOpacity: 0.8
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b1",
  x1: "100%",
  y1: "125.759%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#181A2F",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F90",
  stopOpacity: 0.8
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c1",
  x1: "100%",
  y1: "125.759%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#181A2F",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F90",
  stopOpacity: 0.8
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d1",
  x1: "100%",
  y1: "125.759%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#181A2F",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F90",
  stopOpacity: 0.8
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e1",
  x1: "100%",
  y1: "125.759%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#181A2F",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F90",
  stopOpacity: 0.8
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: -0.006,
  opacity: 0.2,
  transform: "translate(16.485 96.66)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 148.515,
  y: 230
}, "2018")), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: -0.006,
  opacity: 0.2,
  transform: "translate(16.485 96.66)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 198.515,
  y: 230
}, "2019")), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: -0.006,
  opacity: 0.2,
  transform: "translate(16.485 96.66)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 100.515,
  y: 230
}, "2017")), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: -0.006,
  opacity: 0.2,
  transform: "translate(16.485 96.66)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 53.515,
  y: 230
}, "2016")), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: -0.006,
  opacity: 0.2,
  transform: "translate(16.485 96.66)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 8,
  y: 230
}, "2015")), /*#__PURE__*/React.createElement("path", {
  fill: "url(#a1)",
  d: "M37.724 183.026c0-8.91-7.211-16.134-16.105-16.134s-16.104 7.224-16.104 16.134v19.53h32.209v-19.53z",
  transform: "translate(16.485 96.66)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b1)",
  d: "M83.724 155.026c0-8.911-7.21-16.134-16.105-16.134-8.893 0-16.104 7.223-16.104 16.134v47.834h32.209v-47.834z",
  transform: "translate(16.485 96.66)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#c1)",
  d: "M131.724 109.026c0-8.911-7.211-16.134-16.105-16.134s-16.104 7.223-16.104 16.134v93.686h32.209v-93.686z",
  transform: "translate(16.485 96.66)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#d1)",
  d: "M179.724 64.026c0-8.91-7.211-16.134-16.105-16.134s-16.104 7.224-16.104 16.134V203h32.209V64.026z",
  transform: "translate(16.485 96.66)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#e1)",
  d: "M227.724 37.026c0-8.91-7.211-16.134-16.105-16.134s-16.104 7.224-16.104 16.134V203h32.209V37.026z",
  transform: "translate(16.485 96.66)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  stroke: "#FFF",
  strokeLinecap: "square",
  d: "M22 299.91l225.5-.41",
  opacity: 0.068
}), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 11,
  fontWeight: 400,
  letterSpacing: 1,
  transform: "translate(16.485 96.66)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 151.216,
  y: 36.341
}, "10m")), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 11,
  fontWeight: 400,
  letterSpacing: 1,
  transform: "translate(16.485 96.66)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 198.216,
  y: 10.341
}, "12m")), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 11,
  fontWeight: 400,
  letterSpacing: 1,
  transform: "translate(16.485 96.66)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 105.842,
  y: 82.341
}, "7m")), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 11,
  fontWeight: 400,
  letterSpacing: 1,
  transform: "translate(16.485 96.66)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 57.842,
  y: 127.341
}, "5m")), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "Roboto-Medium, Roboto",
  fontSize: 11,
  fontWeight: 400,
  letterSpacing: 1,
  transform: "translate(16.485 96.66)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 12.842,
  y: 154.341
}, "2m")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h267v344H0z"
}));

var SvgGraphic = function SvgGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 344,
    viewBox: "0 0 267 344"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/graphic.ccac2d65.svg";
export { SvgGraphic as ReactComponent };